<template>
  <div class="my-carousel-div">
    <div class="my-carousel">
      <el-carousel :interval="1000" type="card" height="470px">
        <el-carousel-item v-for="(item,index) in items" :key="index">
          <el-image style="width: 100%; height: 100%" :src="item.path" fit="fill" :name="item.name" :label="item.name"
            @click="myclick(item.itemId,item.nid)"></el-image>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  import {
    getAllCarousel
  } from '@/api/carousel.js'

  export default {
    name: "Carousel",
    data: function() {
      return {
        items: [],
      }
    },
    methods: {
      myclick: function(itemId, nid) {
        var path = "";
        if (itemId == 0) {
          path = "/"
        } else {
          path = "/item/desc?itemId=" + itemId + "&nid=" + nid
        }
        this.$router.push({
          path: path
        })
      }
    },
    created() {
      getAllCarousel("carousel/getAll", this);
    }
  }
</script>

<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .my-carousel {
    width: 1200px;
    height: 500px;
    margin: 0 auto;
  }

  .my-carousel-div {
    background: #F2F2F2;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/Carousel.vue